import {Component} from 'react';
import "./GameViews/gameViews.css";

class AwardImageCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false, 
        }
        this.initializeDisplay();
    }

    initializeDisplay(){
        this.trophyIdArr = [];
        this.leftArr = [];
        this.pictureClassArr = [];
        this.imgSrcArr = [];
        for (let i=0; i<this.props.awards.shelf.length; i++){
             const shelf = this.props.awards.shelf[i];
            
             let left = (i * 19) + 17  + "%";
             this.leftArr.push(left);
           
             let pictureClass = "trophy_thumbnail_img";
             if (shelf.earned === false){
                  pictureClass += " disabled-picture-3";
             }
             if (shelf.earned === "partial" ){
                   pictureClass += " disabled-picture-2";
             }
            this.pictureClassArr.push(pictureClass);
            let imgSrc = "";
            let trophyId = "";
            if (this.props.awards.type !== "BDG"){
                trophyId = shelf.id;
            }
           
            this.trophyIdArr.push(trophyId);
            imgSrc = shelf.imgSrc;
            this.imgSrcArr.push(imgSrc)
        }
       
    }
    
    render() {
        let trophyIDClass = "trophy_id_position";
        if (this.props.awards.type === "J"){
               trophyIDClass = "jewel_id_position";
        }                
     
    return <>
    <div className="achievementsBackground">
        <div className="row w-100 ml-2 py-0">
            {this.props.awards.shelf[0] ?
                <div className="col-sm-2 mt-5">
                    <img className={this.pictureClassArr[0]} src={this.imgSrcArr[0]}   
                        onClick={() => this.props.displayAwardInfo(this.props.awards.shelf[0],
                            this.props.awards.type )}
                        alt="trophy"/>
                    <div className={trophyIDClass}>
                        {this.trophyIdArr[0]}
                    </div>
                </div>
            :
                null
            }
            {this.props.awards.shelf[1] ?
                <div className="col-sm-2 ml-4 mt-5">
                    <img className={this.pictureClassArr[1]} src={this.imgSrcArr[1]} 
                        onClick={() => this.props.displayAwardInfo(this.props.awards.shelf[1],
                            this.props.awards.type )}
                        alt="trophy"/>
                    <div className={trophyIDClass}>
                        {this.trophyIdArr[1]}
                    </div>
                </div>
            :
                null
            }
            {this.props.awards.shelf[2] ?
                <div className="col-sm-2 ml-4 mt-5">
                    <img className={this.pictureClassArr[2]} src={this.imgSrcArr[2]} 
                        onClick={() => this.props.displayAwardInfo(this.props.awards.shelf[2],
                            this.props.awards.type )}
                        alt="trophy"/>
                    <div className={trophyIDClass}>
                        {this.trophyIdArr[2]}
                    </div>
                </div>
            :
                null
           }
           {this.props.awards.shelf[3] ? 
                <div className="col-sm-2 ml-4 mt-5">
                    <img className={this.pictureClassArr[3]} src={this.imgSrcArr[3]} 
                        onClick={() => this.props.displayAwardInfo(this.props.awards.shelf[3],
                            this.props.awards.type )}
                        alt="trophy"/>
                    <div className={trophyIDClass}>
                        {this.trophyIdArr[3]}
                    </div>
                </div>
            :
                null
            }
           
        </div>
   
        </div>
    </>
    }

}

export default AwardImageCard;